import { Component, OnInit } from '@angular/core';
import { TipoProcessoDocumento } from '../tipo-proc-doc.model';
import { TipoProcessoDocumentoService } from '../tipo-proc-doc.service';
import { Frm } from '../../components/frm/frm.interface';
import { MensagemService, ProgressoService } from 'maestro-ng';
import { Location } from '@angular/common';
import { SelectItem } from 'primeng/api';
import { SelectItemService } from '../../services/select-item.service';

@Component({
  selector: 'app-tipo-proc-doc-frm',
  templateUrl: './tipo-proc-doc-frm.component.html',
  styleUrls: ['./tipo-proc-doc-frm.component.css'],
})
export class TipoProcessoDocumentoFrmComponent implements OnInit, Frm<TipoProcessoDocumento, number> {
  entidade: TipoProcessoDocumento;
  visibilidadeItens: SelectItem[];

  constructor(
    private service: TipoProcessoDocumentoService,
    private mensagemService: MensagemService,
    private progressoService: ProgressoService,
    private selectItemService: SelectItemService,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.entidade = {} as TipoProcessoDocumento;
    this.visibilidadeItens = this.selectItemService.getVisibilidadeItens();
  }

  salvar(): void {
    const isInsercao = this.entidade.id === undefined;

    this.progressoService.modal();
    this.service
      .salvar(this.entidade)
      .then((tipoProcessoDocumento) => {
        this.entidade = tipoProcessoDocumento;
        this.progressoService.fechar();
        this.mensagemService.addSucesso('Sucesso', 'O tipo processo documento foi salvo com sucesso');

        if (isInsercao) {
          this.location.go(`/tipoProcessoDocumento/edicao/${this.entidade.id}`);
        }
      })
      .catch((resposta) => {
        this.progressoService.fechar();
        this.mensagemService.addErro('Erro ao salvar a tipo processo documento', resposta.error);
        this.progressoService.fechar();
      });
  }

  iniciarInsercao(): void {}

  iniciarAlteracao(entidade: TipoProcessoDocumento): void {
    this.entidade = entidade;
  }

  iniciarAlteracaoPorId(id: number): void {
    this.progressoService.modal();
    this.service
      .recuperarPorId(id)
      .then((tipoProcessoDocumento) => {
        this.progressoService.fechar();
        this.iniciarAlteracao(tipoProcessoDocumento);
      })
      .catch((resposta) => {
        this.progressoService.fechar();
        this.mensagemService.addErro('Erro ao recuperar o tipo processo documento para edição', resposta.error);
      });
  }
}
